import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/UserProducts.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/products'

const RouteUserProducts = ({ user, history, ...props }) => (
  <Fragment>
    <PaginatedConnectionTable
      {...props}
      history={history}
      fields={fields}
      onRowClick={(e, row) => history.push(`/admin/products/${row.id}`)}
    />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'user.products'
})(RouteUserProducts)



// WEBPACK FOOTER //
// ./src/routes/admin/users/products/index.js